/** The sound bank's table of contents: every synthesised sound in the game, by id. */

import { BARK_SFX } from './barks';
import { BODY_SFX } from './bodies';
import { CUE_SFX } from './cues';
import { DOG_SFX } from './dogs';
import { DRUM_SFX } from './drums';
import { EXPLOSION_SFX } from './explosions';
import { FIELD_SFX } from './field';
import { FOOTSTEP_SFX } from './footsteps';
import { GEAR_SFX } from './gear';
import type { SfxDef } from './types';
import { WEAPON_SFX } from './weapons';

/** In the order the bank warms them: what the title screen needs first, the long blasts last. */
export const SFX = {
  ...CUE_SFX,
  ...DRUM_SFX,
  ...WEAPON_SFX,
  ...BODY_SFX,
  ...FOOTSTEP_SFX,
  ...BARK_SFX,
  ...DOG_SFX,
  ...FIELD_SFX,
  ...GEAR_SFX,
  ...EXPLOSION_SFX,
} satisfies Record<string, SfxDef>;

export type SfxId = keyof typeof SFX;

export const SFX_IDS = Object.keys(SFX) as SfxId[];

/** The definition behind an id, with the optional fields readable. */
export function sfxDef(id: SfxId): SfxDef {
  return SFX[id];
}

export { BARK_ID, barkRate } from './barks';
export { CRAWL_ID, STEP_ID } from './footsteps';
export { PRIORITY, type SfxDef } from './types';
